export const dropdownData = [
  { name: "FMGC", path: "/" },
  { name: "Hardware", path: "/" },
];
